import { render, staticRenderFns } from "./HeaderAlerts.vue?vue&type=template&id=58f0b4d9"
import script from "./HeaderAlerts.vue?vue&type=script&lang=js"
export * from "./HeaderAlerts.vue?vue&type=script&lang=js"
import style0 from "./HeaderAlerts.vue?vue&type=style&index=0&id=58f0b4d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports